import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { panelsApi } from "../api/panelsApi";
import type { ListPanelsQuery, ModeratePanelBody } from "../types";

export const panelKeys = {
  all: ["panels"] as const,
  list: (query?: ListPanelsQuery) =>
    [...panelKeys.all, "list", query ?? {}] as const,
  detail: (slug: string) => [...panelKeys.all, "detail", slug] as const,
};

export const usePanelsList = (query: ListPanelsQuery) =>
  useQuery({
    queryKey: panelKeys.list(query),
    queryFn: () => panelsApi.listPanels(query),
  });

export const usePanelDetail = (slug: string | undefined) =>
  useQuery({
    queryKey: panelKeys.detail(slug ?? ""),
    queryFn: () => panelsApi.getPanelBySlug(slug as string),
    enabled: !!slug,
  });

export const useModeratePanel = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id, body }: { id: string; body: ModeratePanelBody }) =>
      panelsApi.moderatePanel(id, body),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: panelKeys.all });
    },
  });
};
